import {
  YOUR_DETAILS_FIELDS,
  PHONE_NUMBER_ALTERNATIVE,
  TITLE,
} from '~/routes/about-you/about-you-form/sections/your-details';


const YOUR_DETAILS_FIELDS_MEASURE = [
  TITLE,
  ...YOUR_DETAILS_FIELDS,
  PHONE_NUMBER_ALTERNATIVE,
];

export const config = {
  AboutIntro: {
    title: 'About you',
  },
  AboutYouForm: {
    YourDetails: {
      title: 'Your details',
    },
    sectionDataTest: 'YourAppointmentMeasure',
    yourDetailsFields: YOUR_DETAILS_FIELDS_MEASURE,
  },
  PhoneNumberInfo: {
    extra: (
      <p>
        We will send you a text message to this mobile number to confirm your appointment.
        This number will also be used to notify you of our arrival time.<br/>
        We may contact you if we need to seek further information about your selected products.
      </p>
    ),
  },
  hideAboutYouTimeSlotComponent: true,
};
